import { Loader2 } from "lucide-react";
import { ChatPreview } from "./types";
import ChatList from "./ChatList";
import { UserProfile } from "@/types/user";

type ChatSidebarProps = {
  loading: boolean;
  chatPreviews: ChatPreview[];
  selectedChatId: string | undefined;
  onSelectChat: (chatId: string) => void;
  onCreateGroupChat?: (name: string, members: UserProfile[]) => void;
  onCreateNewChat?: (member: UserProfile) => void;
};

export default function ChatSidebar({
  loading,
  chatPreviews,
  selectedChatId,
  onSelectChat,
  onCreateGroupChat,
  onCreateNewChat,
}: ChatSidebarProps) {
  return (
    <div className="w-full h-full border-r bg-background flex flex-col overflow-hidden">
      {loading ? (
        <div className="flex h-full items-center justify-center">
          <Loader2 className="h-8 w-8 animate-spin text-primary" />
        </div>
      ) : (
        <ChatList
          chats={chatPreviews}
          onSelectChat={onSelectChat}
          selectedChatId={selectedChatId}
          onCreateGroupChat={onCreateGroupChat}
          onCreateNewChat={onCreateNewChat}
        />
      )}
    </div>
  );
}
